import React, { useState } from "react";
import { db } from "../../../firebaseConfig";
import { collection, addDoc } from "firebase/firestore";
import * as XLSX from "xlsx";
import "./AddResult.css"; // your CSS file

export default function ResultUploader() {
    const [department, setDepartment] = useState("");
    const [program, setProgram] = useState("");
    const [session, setSession] = useState("");
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState({ text: "", type: "" });

    const handleFileUpload = (e) => {
        setFile(e.target.files[0]);
    };

    const uploadResults = async () => {
        if (!department || !program || !session || !file) {
            setMessage({ text: "⚠️ Please select all fields and upload a file.", type: "error" });
            return;
        }

        setUploading(true);
        setMessage({ text: "", type: "" });

        try {
            const data = await file.arrayBuffer();
            const workbook = XLSX.read(data, { type: "array" });

            for (const sheetName of workbook.SheetNames) {
                const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

                for (const row of sheetData) {
                    const colRef = collection(
                        db,
                        "results",
                        department,
                        program,
                        session,
                        sheetName
                    );
                    await addDoc(colRef, row);
                }
            }

            setMessage({ text: "✅ Results uploaded successfully!", type: "success" });
        } catch (error) {
            console.error("❌ Upload error:", error);
            setMessage({ text: "❌ Failed to upload results. Check console.", type: "error" });
        }

        setUploading(false);
    };

    return (
        <div className="container">
            <h2 className="title">Upload Student Results</h2>

            {/* Dropdown filters */}
            <div className="filters">
                <select
                    className="select"
                    value={department}
                    onChange={(e) => setDepartment(e.target.value)}
                >
                    <option value="">Select Department</option>
                    <option value="CS">Computer Science</option>
                </select>

                <select
                    className="select"
                    value={program}
                    onChange={(e) => setProgram(e.target.value)}
                >
                    <option value="">Select Program</option>
                    <option value="BCS">BSCS</option>
                    <option value="BSE">BSSE</option>
                </select>

                <select
                    className="select"
                    value={session}
                    onChange={(e) => setSession(e.target.value)}
                >
                    <option value="">Select Session</option>
                    <option value="Fall 24">Fall 24</option>
                    <option value="Spring 25">Spring 25</option>
                    <option value="Fall 25">Fall 25</option>
                </select>
            </div>

            {/* File upload */}
            <div className="uploadBox">
                <input
                    type="file"
                    accept=".xlsx"
                    onChange={handleFileUpload}
                    className="fileInput"
                />
                <button
                    className="uploadBtn"
                    onClick={uploadResults}
                    disabled={uploading}
                >
                    {uploading ? "Uploading..." : "Upload Results"}
                </button>
            </div>

            {/* Message */}
            {message.text && (
                <div className={`message ${message.type}`}>
                    {message.text}
                </div>
            )}
        </div>
    );
}
